
import Vue from "vue";
import { mapState } from "vuex";
import Keycloak from "keycloak-js";
import NavBarMenu from "@/components/NavBarMenu.vue";
import UserAvatar from "@/components/UserAvatar.vue";
import { AuthService } from "@/services/AuthService";
import CustomerProfileDataService from "../services/CustomerProfileDataService";
// @group General
export default Vue.extend({
  name: "NavBar",
  props: {
    keycloak: Keycloak
  },
  components: {
    UserAvatar,
    NavBarMenu
  },
  data: () => {
    return {
      customerName: "",
      isMenuNavBarActive: false,
      countryFlag: require("@/assets/germany_flag.png"),
      customerDataService: new CustomerProfileDataService()
    };
  },
  computed: {
    menuNavBarToggleIcon() {
      return this.isMenuNavBarActive ? "close" : "dots-vertical";
    },
    menuToggleMobileIcon() {
      return this.isAsideMobileExpanded ? "menu" : "menu";
    },
    darkModeToggleIcon() {
      return this.isDarkModeActive ? "white-balance-sunny" : "weather-night";
    },
    checkSwitchCustomerView() {
      const switchCustomerCache = localStorage.getItem("switchCustomerView");
      return switchCustomerCache == null ? false : true;
    },
    ...mapState([
      "isNavBarVisible",
      "isAsideMobileExpanded",
      "isDarkModeActive",
      "userName",
      "accessDenied",
      "switchCustomerView"
    ])
  },
  methods: {
    fetchData() {
      let switchCustomerData = null;
      switchCustomerData = localStorage.getItem("switchCustomerView");
      if (switchCustomerData != null) {
        switchCustomerData = JSON.parse(switchCustomerData);
      }
      const customerId = switchCustomerData["switchCustomerNumber"];
      this.customerDataService.getCustomerById(customerId).subscribe(
        data => (data.name ? (this.customerName = data.name) : ""),
        e => {
          console.log(e);
        }
      );
      return switchCustomerData == null ? false : true;
    },
    menuToggleMobile() {
      this.$store.commit("asideMobileStateToggle");
    },
    menuNavBarToggle() {
      this.isMenuNavBarActive = !this.isMenuNavBarActive;
    },
    darkModeToggle() {
      this.$store.commit("darkModeToggle");
    },
    notification() {
      this.$buefy.snackbar.open({
        message: "Notification clicked",
        queue: false
      });
    },
    exitCustomerView() {
      this.$buefy.dialog.confirm({
        message: "Do you really want to exit Customer View ?",
        onConfirm: () => {
          localStorage.removeItem("switchCustomerView");

          // It will route to dashboard home if the current route is uploaded-data and then reload to go into current user mode
          // if (this.$route.fullPath.includes("upload") == true) {
          //   console.log("route to home");
          //   this.$router.push({
          //     name: "home",
          //     params: {},
          //   });
          // }
          this.$router.push({ name: "dashboard" });
          this.$router.go(0);
        }
      });
    },
    logOut() {
      // FIXME: This is performing a login-in for now ;)
      new AuthService().logout(this.keycloak);
    }
  }
});
